
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

    @Component
    export default class DeleteConfirmationDialog extends Vue {
        @Prop({ type: Boolean, default: false }) readonly value!: boolean
        @Prop({ type: String, default: null }) readonly documentName!: string | null
        @Prop({ type: Boolean, default: false }) readonly loading!: boolean

        model: boolean = false

        @Watch('value')
        onValueChanged(val: boolean) {
            this.model = val
        }

        @Watch('model')
        onModelChanged(val: boolean) {
            this.$emit('input', val)
        }

        onCancel() {
            this.$emit('cancel')
        }

        onConfirm() {
            this.$emit('confirm')
        }
    }
